<template>
  <label class="form-element">
    <component
      :is="tagName"
      v-bind="$attrs"
      :value="value"
      class="form-element__field" :class="[{ error: errorText }]"
      @input="onInput"
    />
    <span v-if="specialPlaceholder" :placeholder="specialPlaceholder" />
    <div v-if="isValid || errorText" class="form-element__valid" :class="[{ 'errorIcon': errorText, '--disabled': $attrs.disabled }]">
      <SvgIcon :icon="isValid && !errorText ? 'checkmark' : 'error'" />
    </div>
    <span
      v-if="errorText"
      class="form-element__error"
    >
      {{ errorText }}
    </span>
  </label>
</template>

<script lang="ts" src="./FormElement.ts"></script>

<style lang="scss" scoped src="./FormElement.scss"></style>
